import {httpDelete} from '@/shared/api/serve/httpDelete';

export async function signOut() {
  await httpDelete('/sign/out');
}
